import * as StageStatus from '../stageStatus';

export function useStageCore(): boolean {
    return StageStatus.useNewVersion(window.location.href)
}
